/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-branch': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.25 11.25a2.497 2.497 0 00-2.411 1.875H11.25a1.877 1.877 0 01-1.875-1.875v-2.5a3.094 3.094 0 00-.641-1.875h5.105a2.5 2.5 0 100-1.25H6.16a2.5 2.5 0 100 1.25h.089A1.877 1.877 0 018.125 8.75v2.5a3.129 3.129 0 003.125 3.125h2.589a2.496 2.496 0 102.411-3.125zm0-6.25a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM3.75 7.5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm12.5 7.5a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z"/>'
  }
})
